export default __webpack_public_path__ + "static/media/GeraldtonExtraLight.f3aee7d2.woff";